import { useGetInfluencerQuery } from '../../../generated/graphql';
import { useUserStore } from '../stores/user.store';
import { _noop } from '../helpers/general';

export const useInfluencer = (params?: { creatorId?: number }) => {
  const { user } = useUserStore();
  const influencerId = params?.creatorId ?? user?.influencerId;

  const influencerQuery = useGetInfluencerQuery({
    variables: { id: Number(influencerId) },
    skip: !influencerId,
  });

  if (influencerQuery.loading) {
    return {
      isLoading: true,
      influencer: null,
      links: null,
      refetchInfluencer: _noop,
    };
  }

  const influencer = influencerQuery.data?.creator;

  const landingPageLink = influencer?.customURL
    ? `${import.meta.env.VITE_LANDING_PAGE_URL}/${influencer.customURL}`
    : null;

  return {
    error: influencerQuery.error,
    isLoading: influencerQuery.loading,
    influencer: influencerQuery.data?.creator ?? null,
    links: {
      channelPage: influencerQuery.data?.creator?.profileDeepLink ?? null,
      landingPage: landingPageLink,
      checkoutPage: landingPageLink ? `${landingPageLink}/checkout` : null, // <- sub , otp -> stripe
      giftPage: landingPageLink ? `${landingPageLink}/gift` : null,
    },
    refetchInfluencer: influencerQuery.refetch,
  };
};
